
    import { defineComponent } from 'vue';
    import { mdiWeatherSunny,mdiWeatherPartlyCloudy,mdiWeatherCloudy,mdiWeatherFog,mdiWeatherPartlyRainy,mdiWeatherPartlySnowy, mdiWeatherPartlySnowyRainy,
        mdiWeatherSnowyRainy, mdiWeatherPartlyLightning, mdiWeatherSnowy, mdiWeatherSnowyHeavy, mdiWeatherRainy, mdiWeatherPouring, mdiWeatherHail, mdiWeatherLightningRainy } from '@mdi/js';
    import SignageState, { ISignageState, IWeatherByLocationPayload } from '../../store/modules/signage';
    import SignageListState, { ISignageListState } from '../../store/modules/signageList';
    import { ISignageList } from '../../store/interfaces/ISignage';
    import UserState, { IUserState } from '../../store/modules/users';
    import OrganizationState, { IOrganizationState } from '../../store/modules/organizations';
    import BrandingState, { IBrandingState } from '../../store/modules/brandings';
    import { IBranding } from '../../store/interfaces/IBranding';
    import { getModule } from 'vuex-module-decorators';
    import moment from 'moment';
    import DigitalAssetUploadService from '../../services/DigitalAssetUploadService';
    import { Vue3Marquee } from 'vue3-marquee'

    let signageState = {} as ISignageState,
        signageListState = {} as ISignageListState,
        userState = {} as IUserState,
        organizationState = {} as IOrganizationState,
        brandingState = {} as IBrandingState;

    export default defineComponent({  
        data() {
            return {
                textZoneText: '' as string,
                imagePreviewURL: null as any | null,
                imagePreviewURLs: {} as Record<string, string | null>,
                currentWeather: null as any | null,
                isFahrenheit: true as boolean,
                dayText: '' as string,
                dateText: '' as string,
                timeText: '' as string,
                roomCode: 'ROOM CODE' as string,
                receiverDisplayName: 'Receiver Name' as string,
                connectionUrl: '<Connect URL>' as string,
                dateTimeInterval: null as any,
                weatherIconKey: {
                    1000: { icon: mdiWeatherSunny, fill: '#E2D248' },
                    1003: { icon: mdiWeatherPartlyCloudy, fill: '#E2D248' },
                    1006: { icon: mdiWeatherCloudy, fill: '#A7A7A7' },
                    1009: { icon: mdiWeatherCloudy, fill: '#A7A7A7' },
                    1030: { icon: mdiWeatherFog, fill: '#9499AB'},
                    1063: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' },
                    1066: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
                    1069: { icon: mdiWeatherPartlySnowyRainy, fill: '#7C9CE6' },
                    1072: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
                    1087: { icon: mdiWeatherPartlyLightning, fill: '#EEB156' },
                    1114: { icon: mdiWeatherSnowy, fill: '#7CB5E6' },
                    1117: { icon: mdiWeatherSnowyHeavy, fill: '#7CB5E6' },
                    1135: { icon: mdiWeatherFog, fill: '#9499AB' },
                    1147: { icon: mdiWeatherFog, fill: '#9499AB' },
                    1150: { icon: mdiWeatherRainy, fill: '#989FFF' }, //patchy light drizzle
                    1153: { icon: mdiWeatherRainy, fill: '#989FFF' },
                    1168: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
                    1171: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
                    1180: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //patchy light  rain,
                    1183: { icon: mdiWeatherRainy, fill: '#989FFF' }, //light rain
                    1186: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //moderate rain at times
                    1189: { icon: mdiWeatherRainy, fill: '#989FFF' }, //moderate rain
                    1192: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //jeaby rain at time
                    1195: { icon: mdiWeatherPouring, fill: '#989FFF' }, //heavy rain
                    1198: { icon: mdiWeatherRainy, fill: '#989FFF' },
                    1201: { icon: mdiWeatherPouring, fill: '#989FFF' },
                    1204: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
                    1207: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
                    1210: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
                    1213: { icon: mdiWeatherSnowy, fill: '#7CB5E6' },
                    1216: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' }, //patchy moderate snow
                    1219: { icon: mdiWeatherSnowy, fill: '#7CB5E6' }, //moderate snow
                    1222: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' }, //patchy heavy snow
                    1225: { icon: mdiWeatherSnowyHeavy, fill: '#7CB5E6' },
                    1237: { icon: mdiWeatherHail, fill: '#60D8E6' }, //ice pellets
                    1240: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //light rain shower
                    1243: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //moderate of heavy rain shower
                    1246: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //torrential rain shower
                    1249: { icon: mdiWeatherPartlySnowyRainy, fill: '#7C9CE6' }, //light sleet showers
                    1252: { icon: mdiWeatherPartlySnowyRainy, fill: '#7C9CE6' }, //moderate/heavy sleet showers
                    1255: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
                    1258: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
                    1261: { icon: mdiWeatherHail, fill: '#60D8E6' }, // ice pellet showers
                    1264: { icon: mdiWeatherHail, fill: '#60D8E6' },
                    1273: { icon: mdiWeatherPartlyLightning, fill: '#EEB156' }, //pathy light rain w/ thunder
                    1276: { icon: mdiWeatherLightningRainy, fill: '#EEB156' },
                    1279: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' }, //patchy light snow w/ thunder
                    1282: { icon: mdiWeatherSnowyHeavy, fill: '#7CB5E6' },
                } as any,
                speedPxPerSec: 125 as number,
                marqueeDuration: 24 as number,
            }
        },

        props: {
            zoneContent: {
                type: Object,
                default: null
            },
            zoneNumber: {
                type: Number
            },
            zoneHeight: {
                type: Number
            },
            zoneWidth: {
                type: Number
            },
            layoutId: {
                type: String,
                default: null
            },
        },

        components: {
            Vue3Marquee,
        },

        mounted() {
            this.updateMarqueeDuration();
            // Re-measure once fonts are fully loaded to avoid post-load width shifts
            const anyDoc: any = document as any;
            if (anyDoc && anyDoc.fonts && anyDoc.fonts.ready && typeof anyDoc.fonts.ready.then === 'function') {
                anyDoc.fonts.ready.then(() => {
                    this.$nextTick(() => this.updateMarqueeDuration());
                });
            }
            window.addEventListener('resize', this.onWindowResize, { passive: true });
            this.startDateTimeUpdates();
        },

        beforeUnmount() {
            if (this.dateTimeInterval) {
                clearInterval(this.dateTimeInterval);
            }
            window.removeEventListener('resize', this.onWindowResize);
        },

        methods: {
            shouldShowSeparator(content: any, idx?: string | number): boolean {
                if (!this.zoneContent || !this.zoneContent.zoneContent) {
                    return false;
                }

                if (content.zoneType === 'image' && !this.getImagePreviewUrl(content, idx)) {
                    return false;
                }

                const zoneContentArray = this.zoneContent.zoneContent;
                const contentCount = zoneContentArray.length;

                if (contentCount > 1) {
                    return true;
                }

                if (contentCount === 1) {
                    const selectedType = content.zoneType;

                    if (selectedType === 'connectionInfo') {
                        return true;
                    }

                    if (selectedType === 'weather') {
                        return false;
                    }

                    if (selectedType === 'dateTime') {
                        const dateContent = this.getTextContent(content);
                        return dateContent.length > 25;
                    }

                    if (selectedType === 'text') {
                        const textContent = this.getTextContent(content);
                        return textContent.length > 25;
                    }
                }

                return false;
            },

            getImagePreviewUrl(content: any, idx?: string | number): string {
                if (content?.content?.imageFile && idx != null) {
                    const key = String(idx);
                    if (this.imagePreviewURLs[key]) {
                        return this.imagePreviewURLs[key] as string;
                    }
                }

                if (content && content.content && content.content.image && content.content.image.url) {
                    return content.content.image.url;
                }

                if (idx != null) {
                    const key = String(idx);
                    if (this.imagePreviewURLs[key]) {
                        return this.imagePreviewURLs[key] as string;
                    }
                }

                return this.imagePreviewURL ?? '';
            },

            getTextContent(content: any): string {
                switch (content.zoneType) {
                    case 'dateTime':
                        return `${this.dayText}${this.dayText? ',' : ''} ${this.dateText} ${this.timeText}`;
                    case 'weather' :
                        if (!this.currentWeather || (this.isFahrenheit && !this.currentWeather.temp_f) || (!this.isFahrenheit && !this.currentWeather.temp_c)) {
                            return '';
                        }
                        return `${this.isFahrenheit ? Math.floor(this.currentWeather.temp_f) : Math.floor(this.currentWeather.temp_c)}${this.isFahrenheit ? String.fromCharCode(8457) : String.fromCharCode(8451)} ${this.currentWeather && this.currentWeather.condition ? this.currentWeather.condition.text : ''}`;
                    case 'connectionInfo':
                        return `Visit ${this.connectionUrl} on your device - Room Code: ${this.roomCode} - Receiver Name: ${this.receiverDisplayName}`;
                    case 'text':
                        return `${(content && content.content && content.content.text) ? content.content.text : this.textZoneText}`;
                    default:
                        return '';
                }
            },

            async getWeather(location: any) {
                let weather;
                const weatherPayload = {
                    location: location,
                    days: '2'
                } as IWeatherByLocationPayload;

                const weatherResponse = await signageState.getWeatherByLocation(weatherPayload);
                if(weatherResponse.data) {
                    weather = weatherResponse.data;
                    this.currentWeather = weather.current;
                }
                else {
                    this.currentWeather = null;
                }
               
            },

            async loadContent() {
                if(this.zoneContent && this.zoneContent.zoneContent) {
                    this.imagePreviewURLs = {};
                    this.imagePreviewURL = null;
                    for (let i = 0; i < this.zoneContent.zoneContent.length; i += 1) {
                        const imageContent = this.zoneContent.zoneContent[i];
                        if (imageContent.zoneType !== 'image') {
                            continue;
                        }

                        let previewUrl = null as string | null;
                        if (imageContent.content.imageFile) {
                            const previewResult = await DigitalAssetUploadService.getFilePreview(imageContent.content.imageFile);
                            previewUrl = typeof previewResult === 'string' ? previewResult : null;
                        } else if (imageContent.content.image && imageContent.content.image.url) {
                            previewUrl = imageContent.content.image.url;
                        } else {
                            previewUrl = '/images/ditto-icon.png';
                        }

                        this.imagePreviewURLs[String(i)] = previewUrl;
                        if (!this.imagePreviewURL) {
                            this.imagePreviewURL = previewUrl;
                        }
                    }

                    const weatherContent = this.zoneContent.zoneContent.find((x: any) => x.zoneType == 'weather');
                    if(weatherContent) {
                        this.isFahrenheit = weatherContent.content.temperatureScale == 'Fahrenheit';

                        // Reset weather data before fetching to prevent NaN display
                        this.currentWeather = null;

                        let weather;
                        const weatherPayload = {
                            location: weatherContent.content.location,
                            days: '2'
                        } as IWeatherByLocationPayload;

                        const weatherResponse = await signageState.getWeatherByLocation(weatherPayload);
                        if(weatherResponse.data) {
                            weather = weatherResponse.data;
                            this.currentWeather = weather.current;
                        }
                        else {
                            this.currentWeather = null;
                        }
                    } else {
                        this.currentWeather = null;
                    }

                    this.updateDateTime();

                    const connectInfoContent = this.zoneContent.zoneContent.find((x: any) => x.zoneType == 'connectionInfo');
                    if(connectInfoContent) {
                        let branding = null;
                        await userState.fetchMe();

                        if(userState.me && userState.me.organization) {
                            await organizationState.fetchOrganization(userState.me.organization.id, true);
                            const organization = organizationState.getOrganization;

                            await brandingState.fetchBrandings();
                            branding = brandingState.allBrandings?.find(x => x.id === organization.branding.id) ?? {} as IBranding;
                        }

                        if(branding && branding.customDomainURL) {
                            this.connectionUrl = branding.customDomainURL
                        }
                        else {
                            this.connectionUrl = window.location.host.replace('account', 'connect');
                        }
                        
                        await signageListState.fetchSignageLists({ reload: true, includeRoomDetails: true });

                        let lists = [] as ISignageList[];
                        // Use layoutId prop if provided, otherwise fall back to route param
                        const layoutIdToUse = this.layoutId || (this.$route.params.layoutid as string);
                        if(layoutIdToUse){
                            lists = signageListState.signageListsByLayoutId(layoutIdToUse);
                        }
                        if(lists && lists.length > 0) {
                            const listWithRooms = lists.find((x: any) => x.rooms.length > 0);
                            if(listWithRooms && listWithRooms.rooms[0].roomCode) {
                                this.roomCode = listWithRooms.rooms[0].roomCode;
                                if(listWithRooms.rooms[0].devices.length > 0 && listWithRooms.rooms[0].devices[0].displayName)
                                this.receiverDisplayName = listWithRooms.rooms[0].devices[0].displayName
                            }
                           
                        }
                    }

                    const textContent = this.zoneContent.zoneContent.find((x: any) => x.zoneType == 'text');
                    if(textContent) {
                        this.textZoneText = textContent.content.text;
                    }

                    this.updateMarqueeDuration();
                }
            },

            updateMarqueeDuration() {
                const measureContainer = this.$refs.measureContainer as HTMLElement;
                const measureTrack = this.$refs.measureTrack as HTMLElement;
                const visibleEl = this.$refs.visibleContainer as HTMLElement;
                if (measureContainer && measureTrack && visibleEl) {
                    const visibleWidth = visibleEl.clientWidth || this.zoneWidth || 0;
                    const contentWidth = measureTrack.getBoundingClientRect().width;
                    const total = visibleWidth + contentWidth;
                    const minDuration = 4; // seconds
                    if (this.speedPxPerSec > 0 && total > 0) {
                        this.marqueeDuration = Math.max(total / this.speedPxPerSec, minDuration);
                    } else {
                        this.marqueeDuration = minDuration;
                    }
                }
            },
            onWindowResize() {
                this.$nextTick(() => this.updateMarqueeDuration());
            },

            updateDateTime() {
                if (!this.zoneContent || !this.zoneContent.zoneContent) {
                    // Clear date/time if no zone content
                    this.dayText = '';
                    this.dateText = '';
                    this.timeText = '';
                    return;
                }
                const dateTimeContent = this.zoneContent.zoneContent.find((x: any) => x.zoneType == 'dateTime');
                if (dateTimeContent) {
                    const locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language ?? 'en';
                    moment.locale(locale);

                    if(dateTimeContent.content.showDay) {
                        this.dayText = moment().format('dddd'); 
                    }
                    else {
                        this.dayText = '';
                    }

                    if(dateTimeContent.content.showDate) {
                        switch (dateTimeContent.content.dateFormat) {
                            case 'short':
                                this.dateText = moment().format('L');
                                break;
                            case 'long':
                                this.dateText = moment().format('LL');
                                break;
                            default:
                                this.dateText = moment().format('L');
                                break;
                        }
                    } else {
                        this.dateText = ''
                    }

                    if(dateTimeContent.content.showTime) {
                        if(dateTimeContent.content.timeFormat24) {
                            this.timeText = moment().format('H:mm');
                        }
                        else {
                            this.timeText = moment().format('h:mm a');
                        }
                    } else {
                        this.timeText = '';
                    }
                } else {
                    // Clear date/time if no dateTime content
                    this.dayText = '';
                    this.dateText = '';
                    this.timeText = '';
                }
            },

            startDateTimeUpdates() {
                // Update immediately
                this.updateDateTime();
                // Update every second to keep time current
                this.dateTimeInterval = setInterval(() => {
                    this.updateDateTime();
                }, 1000);
            },
        },

        computed: {
            tickerWatchKey(): string {
                try {
                    return JSON.stringify({
                        z: this.zoneContent?.zoneContent?.map((c: any) => ({ t: c.zoneType, x: this.getTextContent(c) })),
                        h: this.zoneHeight,
                        w: this.zoneWidth,
                    });
                } catch(e) {
                    return String(Math.random());
                }
            },
            weatherLayout(): 'tall' | 'medium' | 'small' {
                const height = this.zoneHeight ?? 0;
                const width = this.zoneWidth ?? 0;
                const minMediumWidth = 420;

                if (height > 220) {
                    return 'tall';
                }

                if (height > 150 && height <= 220 && width >= minMediumWidth) {
                    return 'medium';
                }

                return 'small';
            }
        },

        async created() {
            signageState = getModule(SignageState);
            signageListState = getModule(SignageListState);
            userState = getModule(UserState);
            organizationState = getModule(OrganizationState);
            brandingState = getModule(BrandingState);

            if(this.zoneContent) {
                await this.loadContent();
            }
        },

        watch: {
            zoneContent: {
                handler(newVal) {
                    if (newVal) {
                        this.loadContent();
                    }
                },
                deep: true,
                immediate: false
            },
            'zoneContent.zoneContent': {
                handler(){
                    this.$nextTick(() => this.updateMarqueeDuration());
                },
                deep: true,
                immediate: true
            },
            zoneWidth() {
                this.$nextTick(() => this.updateMarqueeDuration());
            },
            zoneHeight() {
                this.$nextTick(() => this.updateMarqueeDuration());
            },
            speedPxPerSec() {
                this.$nextTick(() => this.updateMarqueeDuration());
            }
        }
    })
